<template functional>
    <div :class="['award-logos', 'text--center', props.classes]">
        <img 
            loading="lazy"
            width="555" height="82"
            :src="props.path.replace('{NAME}', props.name)" 
            :alt="`
                Doane Grant Thornton LLP is proud to be recognized as one of 
                Canada's best workplaces for our ${props.year} consecutive year!
            `"
        >
    </div>
</template>

<script>
export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        year: {
            type: String,
            default: '19th'
        },
        classes: {
            type: String,
            default: ''
        },
        path: {
            type: String,
            default: '/static/stories/belong/award-winning/Award_Winning{NAME}.png'
        },
    },
}
</script>

<style lang="scss" scoped>
.award-logos {
    margin-top: var(--mt, 60px);
    margin-bottom: var(--mb, 140px);

    img {
        max-height: 82px;
    }

    @media (max-width: 767px) {
        --mt: 30px;
        --mb: 100px;
    }

    &--reset {
        --mt: 0;
        --mb: 0;
    }
}
</style>